/**
 * Created by Claude on 04.08.2026
 */

const OfferWindow = Prefab.createWindow(
    (offer) => (bundles[offer.bundle].jsons.offer_prefab_json ? offer.bundle : "offers"),
    (offer) => (bundles[offer.bundle].jsons.offer_prefab_json ? "offer_prefab_json" : "offerwindow_prefab_json"),
    {
        theme: (offer) => bundles[offer.bundle].jsons.offer_theme_json,
        bundles: (offer) => [offer.bundle, "offers"]
    }
);

// the tile shop titles an offer tile by the window that sells the offer
OfferWindow.getOfferTitle = function (offer) {
    return `OfferWindow.${offer.name}.title`;
};
